import { createContext } from 'react';

export type AuthUser = {
  id?: string | number;
  email?: string;
  name?: string;
  token?: string;
  family_account_type?: string | null;
  [key: string]: unknown;
};

export type AuthContextValue = {
  user: AuthUser | null;
  loginWithEmail: (...args: unknown[]) => Promise<unknown>;
  logout: () => void;
  loading: boolean;
  verifying: boolean;
  accessPending: boolean;
  profileUnavailable: boolean;
  handleExternalLogin: (...args: unknown[]) => Promise<unknown>;
  refreshUser: () => Promise<AuthUser | null>;
};

/** The one Product auth context identity shared by the provider and its hooks. */
export const authContextValue = createContext<AuthContextValue | undefined>(undefined);
